/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetSearchRecentQueriesResponseAllOf,
    GetSearchRecentQueriesResponseAllOfFromJSON,
    GetSearchRecentQueriesResponseAllOfFromJSONTyped,
    GetSearchRecentQueriesResponseAllOfToJSON,
} from './GetSearchRecentQueriesResponseAllOf';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';
import {
    RecentSearchQuery,
    RecentSearchQueryFromJSON,
    RecentSearchQueryFromJSONTyped,
    RecentSearchQueryToJSON,
} from './RecentSearchQuery';

/**
 * 
 * @export
 * @interface GetSearchRecentQueriesResponse
 */
export interface GetSearchRecentQueriesResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetSearchRecentQueriesResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetSearchRecentQueriesResponse
     */
    message: string;
    /**
     * 
     * @type {Array<RecentSearchQuery>}
     * @memberof GetSearchRecentQueriesResponse
     */
    data: Array<RecentSearchQuery>;
}

export function GetSearchRecentQueriesResponseFromJSON(json: any): GetSearchRecentQueriesResponse {
    return GetSearchRecentQueriesResponseFromJSONTyped(json, false);
}

export function GetSearchRecentQueriesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSearchRecentQueriesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ((json['data'] as Array<any>).map(RecentSearchQueryFromJSON)),
    };
}

export function GetSearchRecentQueriesResponseToJSON(value?: GetSearchRecentQueriesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ((value.data as Array<any>).map(RecentSearchQueryToJSON)),
    };
}

